module.exports = __webpack_public_path__ + "fonts/Source-Sans-Pro-Regular.5cc3aae6.woff";